import { DateTime } from "luxon";
import { getTimeZoneFromSwaStation } from "./timeZoneService";
import { set_time_to_end_of_day, set_time_to_midnight } from "./dateTimeFormatter";

export function TODAY(station) {
  let today = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  today = set_time_to_end_of_day(today);
  return today;
}

export function TOMORROW(station) {
  let tomorrow = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  tomorrow = tomorrow.plus({ day: 1 });
  return tomorrow;
}

export function YESTERDAY(station) {
  let yesterday = TODAY(station);
  yesterday = yesterday.minus({ days: 1 });
  yesterday = set_time_to_midnight(yesterday);
  return yesterday;
}

export function TWO_MONTHS_IN_PAST(station) {
  let twoMonthsInPast = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  twoMonthsInPast = twoMonthsInPast.minus({ months: 2 });
  twoMonthsInPast = set_time_to_midnight(twoMonthsInPast);
  return twoMonthsInPast;
}

export function THREE_MONTHS_IN_PAST(station) {
  let twoMonthsInPast = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  twoMonthsInPast = twoMonthsInPast.minus({ months: 3 });
  twoMonthsInPast = set_time_to_midnight(twoMonthsInPast);
  return twoMonthsInPast;
}

export function ONE_YEAR_IN_PAST(station) {
  let oneYearInPast = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  oneYearInPast = oneYearInPast.minus({ years: 1 });
  oneYearInPast = set_time_to_midnight(oneYearInPast);
  return oneYearInPast;
}

export function THREE_YEARS_IN_PAST(station) {
  let threeYearsInPast = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  threeYearsInPast = threeYearsInPast.minus({ years: 3 });
  threeYearsInPast = set_time_to_midnight(threeYearsInPast);
  return threeYearsInPast;
}

export function TWO_MONTHS_FROM(station, date) {
  let twoMonthsInFuture = date.setZone(getTimeZoneFromSwaStation(station));
  twoMonthsInFuture = twoMonthsInFuture.plus({ months: 2 });
  twoMonthsInFuture = set_time_to_end_of_day(twoMonthsInFuture);
  return twoMonthsInFuture;
}

export function ONE_YEAR_FROM(station, date) {
  let oneYearInFuture = date.setZone(getTimeZoneFromSwaStation(station));
  oneYearInFuture = oneYearInFuture.plus({ years: 1 });
  oneYearInFuture = set_time_to_end_of_day(oneYearInFuture);
  return oneYearInFuture;
}

export function FIFTEEN_DAYS_IN_FUTURE(station) {
  let fifteenDaysInFuture = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  fifteenDaysInFuture = fifteenDaysInFuture.plus({ days: 15 });
  fifteenDaysInFuture = set_time_to_midnight(fifteenDaysInFuture);
  return fifteenDaysInFuture;
}

export function FOURTEEN_DAYS_IN_FUTURE(station) {
  let fifteenDaysInFuture = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  fifteenDaysInFuture = fifteenDaysInFuture.plus({ days: 14 });
  fifteenDaysInFuture = set_time_to_midnight(fifteenDaysInFuture);
  return fifteenDaysInFuture;
}

export function THREE_MONTHS_IN_FUTURE(station) {
  let threeMonthsInFuture = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  threeMonthsInFuture = threeMonthsInFuture.plus({ months: 3 });
  threeMonthsInFuture = set_time_to_midnight(threeMonthsInFuture);
  return threeMonthsInFuture;
}

export function SIX_MONTHS_IN_FUTURE(station) {
  let sixMonthsInFuture = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  sixMonthsInFuture = sixMonthsInFuture.plus({ months: 6 });
  sixMonthsInFuture = set_time_to_midnight(sixMonthsInFuture);
  return sixMonthsInFuture;
}

export function SIX_MONTHS_FROM(station, date) {
  let sixMonthsFromGivenDate = date.setZone(getTimeZoneFromSwaStation(station));
  sixMonthsFromGivenDate = sixMonthsFromGivenDate.plus({ months: 6 });
  sixMonthsFromGivenDate = set_time_to_midnight(sixMonthsFromGivenDate);
  return sixMonthsFromGivenDate;
}

export function THREE_MONTHS_FROM(station, date) {
  let threeMonthsFromGivenDate = date.setZone(getTimeZoneFromSwaStation(station));
  threeMonthsFromGivenDate = threeMonthsFromGivenDate.plus({ months: 3 });
  threeMonthsFromGivenDate = set_time_to_end_of_day(threeMonthsFromGivenDate);
  return threeMonthsFromGivenDate;
}

export function NEXT_LAST_DAY_OF_MONTH(station, month) {
  let currentDateTime = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  let nextLastDay = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  if (currentDateTime.month > month) {
    nextLastDay = nextLastDay.plus({ year: 1 });
  }
  nextLastDay = nextLastDay.set({
    month: month,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  nextLastDay = nextLastDay.set({
    day: nextLastDay.daysInMonth,
  });
  return nextLastDay;
}

export function isDateTimeWithinOneHour(dateTime, station) {
  let now = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  let oneHourFrom = getOneHourBeforeGivenDateTime(dateTime);
  return now.toMillis() >= oneHourFrom.toMillis();
}

export function getOneHourBeforeGivenDateTime(dateTime) {
  let oneHourBeforeLuxonDateTime = dateTime.minus({ hours: 1 });
  return oneHourBeforeLuxonDateTime;
}

export function getTimeDifferenceInMinutes(dateTime1, dateTime2) {
  // Offset is included to ensure DST is covered appropriately
  let timeZoneOffsetDifference = dateTime1.o - dateTime2.o;
  let timeDifference = (dateTime2.toMillis() - dateTime1.toMillis()) / 1000;
  timeDifference /= 60;
  timeDifference = Math.abs(Math.round(timeDifference)) - Math.max(0, timeZoneOffsetDifference);
  return timeDifference;
}

export function isDateTimeInPast(dateTime, station) {
  let now = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  return dateTime.toMillis() <= now.toMillis();
}

export function isDateTimeGreaterThanTwoMonthsInPast(dateTime, station) {
  let twoMonthsInPast = TWO_MONTHS_IN_PAST(station);
  return dateTime.toMillis() < twoMonthsInPast.toMillis();
}

export const isDSTDay = (luxonDateTime) => {
  const midnightDateTime = luxonDateTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const nextDay = midnightDateTime.plus({ days: 1 });
  return midnightDateTime.offset !== nextDay.offset;
};

export function getThanksGivingDateOfTheYear(year) {
  const firstDayOfNovember = DateTime.fromObject({ year, month: 11, day: 1 });
  const firstThursday = firstDayOfNovember.plus({ days: (4 - firstDayOfNovember.weekday + 7) % 7 }); // 4 represents Thurday, additional 7 is to avoid -ve values
  return firstThursday.plus({ weeks: 3 }); //Add 3 more weeks to get 4th Thursday, i.e. Thanksgiving day
}
